import React from "react";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import TexteMultiligne from "../indicateurs/TexteMultiligne";

class SurfaceRemarques extends React.Component {
  handleChangeIndicateur = (newIndicateur) => {
    const { changeIndicateur, sousRubriqueIndex, libelleEnglobantIndex } = this.props;
    changeIndicateur(newIndicateur, sousRubriqueIndex, libelleEnglobantIndex);
  };
  render() {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <TexteMultiligne
          inputProps={{
            multiline: true,
            rows: 2,
            rowsMax: 4,
            style: {
              maxWidth: "70%",
            },
            label: "Remarques",
          }}
          indicateur={this.props.indicateurs["HVE4_CULT_D_96"]}
          key={"indicateur-" + this.props.indicateurs["HVE4_CULT_D_96"].idIndicateur}
          changeIndicateur={this.handleChangeIndicateur}
          computedFields={this.props.computedFields}
        />
      </div>
    );
  }
}

export default compose(withTranslation())(SurfaceRemarques);
